import { NgModule } from '@angular/core';
import { OptionModule } from '../abstract/option.module';
import { OptionNumberComponent } from './option-number.component';

@NgModule({
  imports: [OptionModule],
  declarations: [OptionNumberComponent],
  exports: [OptionNumberComponent]
})
export class OptionNumberModule {}
